var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"create-data-page"}},[_c('h2',{staticClass:"intro-y text-lg font-medium mt-10"},[_vm._v(" 預約 ")]),(_vm.checkPermission(_vm.permissions, 'site.resource-booking.create'))?_c('resource-booking-form',{attrs:{"site":_vm.currentSite}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }